// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1d-zm","disabled":"FileBtn_disabled__1IX4U","warn":"FileBtn_warn__KW5Z5","fade":"FileBtn_fade__25KRX"};